import { useState } from "react";
import "@/App.css";
import { Toaster } from "sonner";

import useSeoMeta from "@/hooks/useSeoMeta";
import WelcomePopup from "@/components/WelcomePopup";
import HeroSection from "@/components/HeroSection";
import ServicesSection from "@/components/ServicesSection";
import EstimateSection from "@/components/EstimateSection";
import MarketingBanner from "@/components/MarketingBanner";
import ProjectsSection from "@/components/ProjectsSection";
import TeamSection from "@/components/TeamSection";
import Footer from "@/components/Footer";
import ContactModal from "@/components/ContactModal";
import ScrollToTopButton from "@/components/ScrollToTopButton";

const TOAST_OPTIONS = {
  style: { background: '#F9F7F2', border: '1px solid #B1D8B7', color: '#1A1A1A' }
};

function App() {
  const [modalOpen, setModalOpen] = useState(false);
  const [serviceType, setServiceType] = useState('residential');

  useSeoMeta();

  const openModal = (type) => {
    setServiceType(type);
    setModalOpen(true);
  };

  return (
    <div className="App" data-testid="app-container">
      <Toaster position="top-right" toastOptions={TOAST_OPTIONS} />

      <WelcomePopup />
      <HeroSection onOpenModal={openModal} />
      <ServicesSection />
      <EstimateSection />
      <MarketingBanner />
      <ProjectsSection />
      <TeamSection />
      <Footer />

      <ContactModal
        isOpen={modalOpen}
        onClose={() => setModalOpen(false)}
        serviceType={serviceType}
      />

      <ScrollToTopButton />
    </div>
  );
}

export default App;
